function locationFormatter(cell, row) {
  return <div>{cell} {row["city"]}</div>;
}
export default locationFormatter;
